import { inject } from 'inversify-props';
import { IStorage } from '../../services';
import { SearchRequest } from '../common/SearchRequest';
import { Company } from '../industry/Company';
import { Artist } from '../industry/Artist';
import { Pro } from '../industry/Pro';
import { Series } from './Series';
import { Category } from './Category';
import { Technology } from './Technology';


export class DeckSearchRequest extends SearchRequest {

	@inject('IStorage')
	public storage: IStorage;

	public categoryIds: number[] = [];
	public technologyIds: string[] = [];
	public seriesIds: string[] = [];
	public proIds: string[] = [];
	public artistIds: string[] = [];
	public companyIds: string[] = [];
	public categories: Category[] = [];
	public companies: Company[] = [];
	public pros: Pro[] = [];
	public technologies: Technology[] = [];
	public artists: Artist[] = [];
	public series: Series[] = [];

	public startYear?: number;
	public endYear?: number;

	public isEnabled?: boolean = null;

	constructor(init?: any) {
		super(init);
		if (!init) { return; }
		if (init.companyIds) {
			this.companyIds = Array.isArray(init.companyIds) 
				? init.companyIds 
				: init.companyIds.split(',');
		}
		if (init.technologyIds) {
			this.technologyIds = Array.isArray(init.technologyIds)
				? init.technologyIds
				: init.technologyIds.split(',');
		}
		if (init.artistIds) {
			this.artistIds = Array.isArray(init.artistIds)
				? init.artistIds
				: init.artistIds.split(',');
		}
		if (init.proIds) {
			this.proIds = Array.isArray(init.proIds) 
				? init.proIds
				: init.proIds.split(',');
		}
		if (init.seriesIds) {
			this.seriesIds = Array.isArray(init.seriesIds)
				? init.seriesIds
				: init.seriesIds.split(',');
		}
		if (init.categoryIds) {
			if (Array.isArray(init.categoryIds)) {
				this.categoryIds = init.categoryIds;
			} else {
				const categories = init.categoryIds.split(',');
				this.categoryIds = categories.map((x) => parseInt(x, null));
			}
		}
		if (init.startYear) { this.startYear = parseInt(init.startYear, null); }
		if (init.endYear) { this.endYear = parseInt(init.endYear, null); }
		if (init.isEnabled != null) { this.isEnabled = (init.isEnabled.toString() === 'true'); }

		// INSTEAD OF GETTING THESE VALUES FROM THE DATABASE, TRY AND GET THEM FROM LOCAL STORAGE
		const json = this.storage.retrieve('deck-filter');
		if (!json) { return; }

		const prevFilter = JSON.parse(json) as DeckSearchRequest;
		if (!prevFilter) { return; }

		if (prevFilter?.companies?.length) {
			for (const id of this.companyIds) {
				const found = prevFilter.companies.find((x) => x.id === id);
				if (found) { this.companies.push(found); }
			}
		}

		if (prevFilter?.artists?.length) {
			for (const id of this.artistIds) {
				const found = prevFilter.artists.find((x) => x.id === id);
				if (found) { this.artists.push(found); }
			}
		}

		if (prevFilter?.pros?.length) {
			for (const id of this.proIds) {
				const found = prevFilter.pros.find((x) => x.id === id);
				if (found) { this.pros.push(found); }
			}
		}

		if (prevFilter?.technologies?.length) {
			for (const id of this.technologyIds) {
				const found = prevFilter.technologies.find((x) => x.id === id);
				if (found) { this.technologies.push(found); }
			}
		}

		if (prevFilter?.series?.length) {
			for (const id of this.seriesIds) {
				const found = prevFilter.series.find((x) => x.id === id);
				if (found) { this.series.push(found); }
			}
		}

		if (prevFilter?.categories?.length) {
			for (const id of this.categoryIds) {
				const found = prevFilter.categories.find((x) => x.id === id);
				if (found) { this.categories.push(found); }
			}
		}

	}

	/** Collapses the values in this search request object so they can be persisted to a query string */
	public collapse(): any {
		const response: { [k: string]: any } = super.collapse();
		if (this.companyIds && this.companyIds.length) { response.companyIds = this.companyIds.join(','); }
		if (this.technologyIds && this.technologyIds.length) { response.technologyIds = this.technologyIds.join(','); }
		if (this.artistIds && this.artistIds.length) { response.artistIds = this.artistIds.join(','); }
		if (this.proIds && this.proIds.length) { response.proIds = this.proIds.join(','); }
		if (this.seriesIds && this.seriesIds.length) { response.seriesIds = this.seriesIds.join(','); }
		if (this.categoryIds && this.categoryIds.length) { response.categoryIds = this.categoryIds.join(','); }
		if (this.startYear) { response.startYear = this.startYear; }
		if (this.endYear) { response.endYear = this.endYear; }
		if (this.isEnabled != null) { response.isEnabled = this.isEnabled; }
		return response;
	}

	/** Clears the values in this search request object */
	public clear() {
		super.clear();
		this.artistIds = [];
		this.technologyIds = [];
		this.categoryIds = [];
		this.companyIds = [];
		this.proIds = [];
		this.seriesIds = [];
		this.isEnabled = null;
	}

}
